import moment from "moment"

/*
 * Returns minimum allowed reporting date in YYYY-MM-DD format
 * If commitment.startDate is in the current year, returns commitment.startDate (These should not be reported at all)
 * If commitment.startDate is in the previous year, returns commitment.startDate
 * If commitment.startDate is dated back more than a year, eg. (startDate is in 2019 and its 2021),
 * returns the first day of the previous year (2020-01-01)
 *
 * If commitment type is CIRCULAR_ECONOMY, returns either commitment.startDate OR date of previous report
 */
export const getMinReportingDate = (commitment) => {
    const commitmentDate = moment(commitment.startDate)
    const today = moment()
    if (moment(commitmentDate).year() < moment(today).year()) {
        return moment(commitmentDate).year() < moment(today).subtract(1, "years").year() 
        ? moment(today).subtract(1, "years").startOf('year').format("YYYY-MM-DD")
        : moment(commitmentDate).format("YYYY-MM-DD")
    }
    return commitmentDate
}

/* 
 * Return maximum allowed reporting date in YYYY-MM-DD format
 * If commitment.startDate is in the current year, return the last day of the current year (20XX-12-31)
 * If commitment.startDate is in the previous year, return the last day of that year
 * If commitment.startDate is dated back more than a year, eg. (startDate is in 2019 and its 2021),
 * return the last day of that year (in this case, 2019-12-31)
 *
 * CIRCULAR ECONOMY commitments are reported every x years and first reporting year is 2027:
 * @TODO logic is unclear, so for now return end of 2027.
 */
export const getMaxReportingDate = (commitment) => {
    const commitmentDate = moment(commitment.startDate)
    const today = moment()
    if(commitment.commitmentType === "CIRCULAR_ECONOMY"){
        return "2027-12-31";
    }
    if (moment(commitmentDate).year() < moment(today).year()) {
        return moment(commitmentDate).year() < moment(today).subtract(1, "years").year() 
        ? moment(today).subtract(1, "years").endOf('year').format("YYYY-MM-DD")
        : moment(commitmentDate).endOf('year').format("YYYY-MM-DD")
    }
    return moment(today).endOf('year').format("YYYY-MM-DD");
}


// WEBPACK FOOTER //
// ./src/components/profile/reports/helpers/Dates.js